import { Box, Button, Fade, Grid, TextField, Typography } from '@material-ui/core'
import FieldWrapper from 'components/FieldWrapper'
import ViewWrapperPublic from 'components/ViewWrapperPublic/ViewWrapperPublic'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { getHeader } from 'utils/utils'
import { useReactivateRegistration } from './useReactivateRegistration'
import colors from 'utils/colors'

const ReactivateRegistration = (): JSX.Element => {
    const { success, loading, history, customerID, setCustomerID, requestNewLink } = useReactivateRegistration()
    const { t } = useTranslation()

    return (
        <ViewWrapperPublic header={getHeader(`/${t('url.dashboard')}`, history, t, [])} loading={false}>
            <Box marginTop={'5%'} marginBottom={'5%'} marginLeft={'10%'} marginRight={'10%'}>
                <FieldWrapper text="">
                    <Grid container spacing={6} style={{ backgroundColor: '#f8f8f8', color: colors.blue }}>
                        <Grid item xs={12}>
                            <Typography variant="h4">{t('pages.reactivateRegistration.title')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography variant="body1">{t('pages.reactivateRegistration.helperText')}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                variant="filled"
                                fullWidth
                                label={t('pages.reactivateRegistration.customerID')}
                                value={customerID}
                                onChange={(e) => setCustomerID(e.target.value)}
                                inputProps={{
                                    style: { backgroundColor: 'white' },
                                }}
                                style={{ marginTop: 15 }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                style={{ color: colors.blue, backgroundColor: '#fbc10f', fontWeight: 'bolder' }}
                                disabled={loading || success}
                                onClick={requestNewLink}
                            >
                                {t('pages.reactivateRegistration.submit')}
                                {loading && <>...</>}
                            </Button>
                        </Grid>
                    </Grid>
                </FieldWrapper>
                <FieldWrapper text="">
                    <Grid container spacing={3} style={{ backgroundColor: '#ffffff', color: colors.blue }}>
                        <Fade in={success} timeout={1000}>
                            <Grid item xs={12}>
                                <Typography variant="body1" style={{ marginTop: 15 }}>
                                    {t('pages.reactivateRegistration.message')}
                                </Typography>
                            </Grid>
                        </Fade>
                    </Grid>
                </FieldWrapper>
            </Box>
        </ViewWrapperPublic>
    )
}

export default ReactivateRegistration
